import { Avatar, Box, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material'
import moment from 'moment'
import CurrencyFormat from 'react-currency-format'
import StarIcon from "@mui/icons-material/Star";
import React from 'react';

export default function Order({order}) {
    
    
  return (
    <Box sx={{mx:2}}>

        <Typography >{moment.unix(order.data.created).format("MMM DO YYYY h:mma")}</Typography>
        <Typography sx={{textAlign:{xs:"right"},my:4 , mx:3}}>{order.id}</Typography>

        {order.data.basket?.map((item)=> (
            <List
            key={item}
            sx={{
              width: { md: "80%", sx: "100%", lg: "70%" },
              maxWidth: "100%",
              bgcolor: "background.paper",
            }}
          >
            <ListItem
              sx={{
                display: "flex",
                alignItems: { sm: "flex-start", xs: "center" },
                justifyContent: { sm: "flex-start", xs: "center" },
                textAlign: { sm: "start", xs: "center" },
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <ListItemAvatar >
                <Avatar
                  alt="Remy Sharp"
                  src={item.img}
                  sx={{ width: "60%" ,
                   height:"60%" ,
                    borderRadius:0,
                    m:{xs:"0 auto" , sm:0},

                    

                  }}
                />
              </ListItemAvatar>
  
              <ListItemText
                sx={{
                  ".MuiTypography-body1": {
                    fontWeight: 800,
                    fontSize: "18px",
                    textAlign: { sm: "left", sx: "center" },
                  },
                }}
                primary={item.title}
                secondary={
                  <React.Fragment>
                    <Typography
                      component="p"
                      variant="body1"
                      ml={{ sm: 4, xs: 0 }}
                      mt={3}
                      sx={{ color: "text.primary", fontWeight: 600 }}
                    >
                      {item.price}$
                    </Typography>
  
                    <Typography
                      sx={{
                        display: "flex",
                        ml: { sm: 2, xs: 0 },
                        justifyContent: { sm: "left", xs: "center" },
                      }}
                    >
                      {Array(item.rate)
                        .fill()
                        .map((i) => (
                          <Box key={i}>
                            <StarIcon color="warning" />
                          </Box>
                        ))}
                    </Typography>
  
                  </React.Fragment>
                }
              />
            </ListItem>
            <Divider
              variant="inset"
              component="li"
              sx={{ bgcolor: "#999", width: { xs: "100%" }, m: { xs: 0 } }}
            />
          </List>
            ))}


            <CurrencyFormat
            renderText={(value) => (
            <h3 style={{ textAlign: "left", marginLeft: 10 , fontWeight:900}}>
                 Order Total : {value}
            </h3>
            )}
            decimalScale={2}
            value={order.data.amount * 100}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
        />

    </Box>
  )
}
